module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('sub-ibox-title', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("模板消息管理")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {}, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.list.length > 0),
      expression: "list.length > 0"
    }],
    staticClass: "z-btn z-btn-primary b-r-3",
    on: {
      "click": _vm.handleCloseTplMsg
    }
  }, [_vm._v("关闭模板消息")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.list.length <= 0),
      expression: "list.length <= 0"
    }],
    staticClass: "z-btn z-btn-primary b-r-3",
    on: {
      "click": _vm.handleOpenTplMsg
    }
  }, [_vm._v("开启模板消息")])]), _vm._v(" "), _c('z-table', {
    staticClass: "m-t-15",
    attrs: {
      "offset": 0,
      "count": 1,
      "total-count": 1
    }
  }, [_vm._l((_vm.columns), function(item) {
    return _c('th', {
      attrs: {
        "slot": "columns"
      },
      slot: "columns"
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _vm._l((_vm.list || []), function(item, index) {
    return _c('tr', {
      attrs: {
        "slot": "datasource"
      },
      slot: "datasource"
    }, [_c('td', [_vm._v(_vm._s(item.tpl_num))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.topcolor))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.textcolor))])])
  }), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.list.length <= 0),
      expression: "list.length <= 0"
    }],
    attrs: {
      "slot": "datasource"
    },
    slot: "datasource"
  }, [_c('td', {
    attrs: {
      "colspan": "20"
    }
  }, [_c('p', {
    staticClass: "p-20"
  }, [_vm._v("暂无记录 (˘•ω•˘)")])])])], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-c8ef72bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/wechat/WxTplMsg.vue
// module id = 886
// module chunks = 0